export class AdmissionDetails {
  admissionStatus: number;
  admissionDate: Date;
  admissionNotes: string;
  roomId: string;
}
